import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { generateCpuItems, generateInstanceConfigItems, generateRamItems } from '../../../utils';
var nodeConfigItems = generateInstanceConfigItems([[2, 4], [4, 8], [8, 16], [16, 32]]);
var masterNodeCount = generateCpuItems([1, 3, 5]);
var GuaranteedPartItem = {
  '10': '10',
  '30': '30',
  '100': '100'
};
var guaranteedPartCards = [{
  value: GuaranteedPartItem[10],
  label: '10% доля',
  description: 'Для тестирования и несложных приложений'
}, {
  value: GuaranteedPartItem[30],
  label: '30% доля',
  description: 'Для стандартной рабочей нагрузки'
}, {
  value: GuaranteedPartItem[100],
  label: '100% доля',
  description: 'Для высоконагруженных сервисов'
}];
var guaranteedPartToVCpuMap = _defineProperty(_defineProperty(_defineProperty({}, GuaranteedPartItem[10], [2, 4, 8]), GuaranteedPartItem[30], [2, 4, 8, 16, 24, 32]), GuaranteedPartItem[100], [2, 4, 8, 16, 24, 32]);
var guaranteedPartVCpuToRamMap = _defineProperty(_defineProperty(_defineProperty({}, GuaranteedPartItem[10], {
  '2': [4],
  '4': [8, 16, 32],
  '8': [16, 32]
}), GuaranteedPartItem[30], {
  '2': [4],
  '4': [8, 16, 32, 64],
  '8': [16, 32, 64],
  '16': [32, 64],
  '24': [48],
  '32': [64]
}), GuaranteedPartItem[100], {
  '2': [4],
  '4': [8, 16, 32, 64],
  '8': [16, 32, 64, 128],
  '16': [32, 64, 128, 256],
  '24': [48],
  '32': [64, 128, 256]
});
export var EVOLUTION_KUBERNETES_FORM_CONFIG = {
  ui: ['masterNode', 'workerNode', 'bindingPublicIpAddress'],
  controls: {
    masterNode: {
      ui: [['masterNodeConfig', 'masterNodeCount']],
      type: CONTROL.Object,
      decoratorProps: {
        label: 'Мастер-узел'
      },
      controls: {
        masterNodeConfig: {
          type: CONTROL.SelectSingle,
          accessorKey: 'masterNode.nodeConfig',
          items: nodeConfigItems,
          decoratorProps: {
            label: 'Конфигурация мастер-узла'
          },
          defaultValue: '2 4'
        },
        masterNodeCount: {
          type: CONTROL.Segmented,
          accessorKey: 'masterNode.nodeCount',
          defaultValue: masterNodeCount[0].value,
          items: masterNodeCount,
          decoratorProps: {
            label: 'Количество мастер-узлов'
          }
        }
      }
    },
    workerNode: {
      type: CONTROL.ToggleObject,
      switchKey: 'workerNodeNeeded',
      decoratorProps: {
        label: 'Узлы для запуска контейнера'
      },
      control: {
        type: CONTROL.Object,
        ui: ['guaranteedPart', ['vCpuCount', 'ramAmount'], ['nodeCount'], ['diskSize']],
        decoratorProps: {
          label: 'Рабочие узлы'
        },
        controls: {
          guaranteedPart: {
            type: CONTROL.Carousel,
            accessorKey: 'workerNode.guaranteedPart',
            defaultValue: guaranteedPartCards[0].value,
            items: guaranteedPartCards,
            decoratorProps: {
              label: 'Гарантированная доля vCPU',
              labelTooltip: 'Гарантированная доля vCPU определяет долю использования процессора, выделенную для виртуальной машины. Этот параметр известен также как переподписка vCPU (vCPU Overcommitment). При 100% гарантируется использование полной мощности виртуальных ядер процессора хоста виртуализации, выделенных виртуальной машине.'
            }
          },
          vCpuCount: {
            type: CONTROL.Slider,
            accessorKey: 'workerNode.vCpuCount',
            defaultValue: '2',
            items: [2, 4, 8],
            decoratorProps: {
              label: 'Количество ядер vCPU',
              labelTooltip: 'Виртуальные ядра'
            },
            watchedControls: {
              guaranteedPart: 'workerNode.guaranteedPart'
            },
            relateFn: function relateFn(_ref) {
              var guaranteedPart = _ref.guaranteedPart;
              var items = guaranteedPartToVCpuMap === null || guaranteedPartToVCpuMap === void 0 ? void 0 : guaranteedPartToVCpuMap[guaranteedPart];
              if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                return {
                  items: items
                };
              }
            }
          },
          ramAmount: {
            type: CONTROL.Segmented,
            accessorKey: 'workerNode.ramAmount',
            defaultValue: '4',
            items: generateRamItems([4]),
            decoratorProps: {
              label: 'Количество оперативной памяти RAM'
            },
            watchedControls: {
              guaranteedPart: 'workerNode.guaranteedPart',
              vCpuCoreCount: 'workerNode.vCpuCount'
            },
            relateFn: function relateFn(_ref2) {
              var _guaranteedPartVCpuTo2;
              var guaranteedPart = _ref2.guaranteedPart,
                vCpuCoreCount = _ref2.vCpuCoreCount;
              var items = guaranteedPartVCpuToRamMap === null || guaranteedPartVCpuToRamMap === void 0 ? void 0 : (_guaranteedPartVCpuTo2 = guaranteedPartVCpuToRamMap[guaranteedPart]) === null || _guaranteedPartVCpuTo2 === void 0 ? void 0 : _guaranteedPartVCpuTo2[vCpuCoreCount];
              if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                return {
                  items: generateRamItems(items)
                };
              }
            }
          },
          nodeCount: {
            type: CONTROL.Stepper,
            accessorKey: 'workerNode.nodeCount',
            defaultValue: 1,
            decoratorProps: {
              label: 'Количество узлов'
            },
            uiProps: {
              min: 1,
              max: 50,
              postfix: 'Шт'
            }
          },
          diskSize: {
            type: CONTROL.Stepper,
            accessorKey: 'workerNode.diskSize',
            defaultValue: 10,
            decoratorProps: {
              label: 'Диск'
            },
            uiProps: {
              min: 10,
              max: 64,
              postfix: 'ГБ'
            }
          }
        }
      }
    },
    bindingPublicIpAddress: {
      type: CONTROL.Toggle,
      accessorKey:
      // Так специально
      'bindingPublickIpAddress',
      defaultValue: false,
      decoratorProps: {
        label: 'Аренда публичного IP'
      }
    }
  }
};